import React from 'react';
import PropTypes from 'prop-types';
import MaterialIcon from 'material-icons-react';

import './InfoMessage.scss';

const InfoMessage = (props) => {
  const icons = {
    success: 'done',
    warning: 'warning',
    danger: 'error',
  };
  let timeoutId;

  if (props.time && props.show) {
    clearTimeout(timeoutId);
    timeoutId = setTimeout(() => {
      props.onDismiss();
      clearTimeout(timeoutId);
    }, +props.time);

    return (
      <div
        className={`info-message alert alert-${props.type}`}
      >
        <MaterialIcon icon={icons[props.type]} />
        {props.children}
        <button
          type="button"
          className="close alert-close"
          aria-label="Close"
          onClick={()=> {clearTimeout(timeoutId);props.onDismiss()}}
        >
          <MaterialIcon icon="clear" size="tiny" />
        </button>
      </div>
    );
  }

  return null;

};

export default InfoMessage;

InfoMessage.propTypes = {
  type: PropTypes.string.isRequired,
  show: PropTypes.bool.isRequired,
  time: PropTypes.string,
  children: PropTypes.oneOfType([
    PropTypes.arrayOf(PropTypes.node),
    PropTypes.node,
  ]).isRequired,
  onDismiss: PropTypes.func.isRequired,
};

InfoMessage.defaultProps = {
  time: '',
};
